import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';

export function Hero({ onBeginBooking }) {
  return (
    <section 
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden bg-background"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/26045671/pexels-photo-26045671.jpeg?auto=compress&cs=tinysrgb&w=1920"
          alt="Leopard skin pattern"
          className="w-full h-full object-cover opacity-35"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-background/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/60 to-background/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-24 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p className="text-xs md:text-sm tracking-[0.3em] uppercase text-gold mb-6">
            Exotic Animals Miami
          </p>

          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tight leading-[0.9] text-white mb-6">
            Private Exotic<br />
            <span className="text-gold">Animal Experiences</span>
          </h1>

          <p className="text-base md:text-lg text-white/70 max-w-lg mb-10 leading-relaxed">
            Private. Professional. Unforgettable.
          </p>

          <div className="w-24 h-px bg-gold/50 mb-10" />

          <button
            data-testid="begin-booking-btn"
            onClick={onBeginBooking}
            className="group inline-flex items-center gap-3 px-8 py-4 border border-white/30 text-white text-sm tracking-wider uppercase hover:bg-white/10 transition-all duration-300"
          >
            Build Your Experience
            <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform duration-300" />
          </button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <ArrowDown className="w-6 h-6 text-white/40" />
      </motion.div>
    </section>
  );
}
